<app-card-relatorio-laudo [titulo]="template.label" [status]="template.status">
  <div class="d-flex flex-wrap flex-md-nowrap">
    <div class="col">
      <div class="p-1" *ngFor="let e of elementGroup; let i = index">
        <div [ngClass]="{'hide-print': e.element?.imprimir === false}">
        <div class="d-flex">
            <span
              [ngClass]="{
                'score-0': e.element.status == 0,
                'score-1': e.element.status == 1,
                'score-2': e.element.status == 2,
                'score-3': e.element.status == 3,
                'score-4': e.element.status == 4,
                'score-5': e.element.status == 5
              }"
              class="number mr-2 f-12"
              >{{ e.element.index }}</span
            >
            <span>{{ e.element.label }}</span>
          </div>
          <div *ngIf="e.obs && e.obs.value" class="text-muted obs">
            {{ e.obs.value }}
          </div>
        </div>

      </div>
    </div>
    <div [style.maxWidth.px]="380" class="w-100 p-lg-5 p-2 m-auto">
      <app-preview-car-full [car]="car"></app-preview-car-full>
    </div>
  </div>
  <div>
    <div
      *ngIf="observacaoPintura?.value != null && observacaoPintura?.value != ''"
      class="obsPintura"
    >
      <span>Observação: </span>
      {{ observacaoPintura.value }}
    </div>

    <ul style="margin-left: -21px; display: flex">
      <span class="score-1 number mr-2"></span
      ><span class="mr-2">Pintura original</span>
      <span class="score-2 number mr-2"></span
      ><span class="mr-2">Pequenos riscos/Amassado</span>
      <span class="score-3 number mr-2"></span
      ><span class="mr-2">Repintura</span>
      <span class="score-4 number mr-2"></span
      ><span class="mr-2">Repintura com massa</span>
      <span class="score-5 number mr-2"></span
      ><span class="mr-2">Avariado</span>
      <span class="score-0 number mr-2"></span
      ><span class="mr-2">Não Aplicavel</span>
    </ul>
  </div>
  <app-lista-img [elements]="template.elements"></app-lista-img>
</app-card-relatorio-laudo>
